import script from "./ViewEnrollmentNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEnrollmentNotes.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./ViewEnrollmentNotes.vue?vue&type=style&index=1&id=87ac45bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ac45bc"]])

export default __exports__